import type { Market } from '@ts-internal/shared-lib';
import { useEffect, useRef } from 'react';

interface Props {
  market: Market;
  reset: () => void;
}

export const useResetFiltersUponMarketChange = ({ market, reset }: Props) => {
  const prevMarket = useRef(market);

  useEffect(() => {
    // skip the first render
    if (prevMarket.current !== market) {
      reset();
      prevMarket.current = market;
    }
  }, [market, reset]);
};
